{
    "CmeList_Column_ID": "ID",
    "CmeList_Column_Description": "Description",
    "CmeList_Column_ChildCMEs": "CMEs",
    "CmeList_Column_TelSyss": "Telephony servers",
    "CmeList_Column_Partitions": "Partitions",
    "CmeList_Column_Users": "Users",
    "CmeList_CountLink_TelSyssAria": "Open telephony servers filtered to this CM Environment",
    "CmeList_CountLink_PartitionsAria": "Open codes filtered to this CM Environment",
    "CmeList_CountLink_UsersAria": "Open application users filtered to this CM Environment",
    "NAME": "CmeListLanguage"
}
